/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Represents different types of investigation modules.
 */
export enum InvestigationTypeModule {
    ALL = 'all',
    LABORATORY = 'laboratory',
    SCREENING = 'screening',
    SUPORT_SCREENING = 'suportScreening',
    INTERNAL_LABORATORY = 'internalLaboratory',
}
